module.exports = __webpack_public_path__ + "img/all_day_icon.b4a7b40d.png";